import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { ToastrService } from 'ngx-toastr';
import { catchError, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FarmUserServiceService {

  constructor(private httpClient: HttpClient, private toastr: ToastrService) { }
  private apiUrl = environment.apiUrl;
  addFarmUser(user:any): Observable<any> {
    return this.httpClient.post(`${this.apiUrl}/FarmUser/AddFarmUser`,user).pipe(
      //catchError(this.error)
    );;
  }
  getFarmUserList(userId:number,name:any,page:any,pageSize:any): Observable<any> {
    return this.httpClient.get(`${this.apiUrl}/FarmUser/GetFarmUserList?userId=${userId}&name=${name}&page=${page}&pageSize=${pageSize}`).pipe(
      //catchError(this.error)
    );;
  }

  getUserDetailById(id:number):Observable<any>{
      return this.httpClient.get(`${this.apiUrl}/FarmUser/GetUserDetailById?id=${id}`).pipe(
        // catchError(this.error)
      );
  }

  updateUserDetail(UserModel: any): Observable<any> {
    return this.httpClient.post(`${this.apiUrl}/FarmUser/UpdateUserDetail`,UserModel).pipe(
      //catchError(this.error)
    );;
  }
}
